import defaultAxiosClient from '../../plugins/axios';

const initialState = {
    customers: [],
    selectedCustomer: {},
    selectedParentCompany: {},
    selectedCustomerDetail: {
        invoiceNameDto: {},
        customerInvoiceAddress: {},
        bonusRateDtos: [],
        shiftTypeDtos: [],
        peppolEndpointDto: {},
    },
    selectedSubdivisions: [],
    availableSubdivisions: [],
    customersMinimalInfo: [],
    bonusTypes: [],
    confirmedEmails: [],
    customerConfirmedEmails:[],
    selectedParentCompanyDetail: {}
};

const customer = {
    namespaced: true,
    state() {
        return {...initialState};
    },
    getters: {
        customers: state => state.customers,
        selectedCustomerDetail: state => state.selectedCustomerDetail,
        selectedParentCompany: state => state.selectedParentCompany,
        selectedSubdivisions: state => state.selectedSubdivisions,
        availableSubdivisions: state => state.availableSubdivisions,
        customersMinimalInfo: state => state.customersMinimalInfo,
        bonusTypes: state => state.bonusTypes,
        confirmedEmails: state => state.confirmedEmails,
        selectedParentCompanyDetail: state => state.selectedParentCompanyDetail
    },
    mutations: {
        setConfirmedEmails(state, payload){
            state.confirmedEmails = payload._embedded.confirmedEmailDtoList;
        },
        resetState(state) {
            Object.assign(state, initialState);
        },
        setCustomers: (state, customerOverviewDtoList) => {
            state.customers = customerOverviewDtoList;
        },
        setSelectedCustomer(state, payload) {
            state.selectedCustomer = payload;
        },
        setSelectedParentCompany(state, payload) {
          state.selectedParentCompany = payload;
        },
        setSelectedCustomerDetail(state, payload) {
            state.selectedCustomerDetail = payload;
        },
        setSelectedParentCompanyDetail(state, payload) {
            state.selectedParentCompanyDetail = payload;
        },
        setSelectedSubdivisions(state, payload) {
            const customer = payload;
            if (customer.subdivisions !== null) {
                state.selectedSubdivisions = state.customers.filter(subdivision => {
                    return customer.subdivisions.includes(subdivision.id);
                });
            }
            else {
                state.selectedSubdivisions = null;
            }
        },
        setSelectedCustomerDetailActiveValue(state, active) {
            state.selectedCustomerDetail = {
                ...state.selectedCustomerDetail,
                active
            };
        },
        setAvailableSubdivisions(state, payload) {
            const customer = payload;
            if (customer.subdivisions !== null) {
                let allCustomersExcludingMyself = state.customers.filter(subdivision => subdivision.id !== customer.id);
                let allCustomersExcludingParent = allCustomersExcludingMyself.filter(parent => parent.id !== customer.parentCompanyId);
                let allCustomersWithoutParent = allCustomersExcludingParent.filter(customer => customer.parentCompanyId === 0);
                state.availableSubdivisions = allCustomersWithoutParent.filter(subdivision => {
                    return !customer.subdivisions.includes(subdivision.id);
                });
            }
            else {
                let allCustomersExcludingMyself = state.customers.filter(subdivision => subdivision.id !== customer.id);
                let allCustomersExcludingParent = allCustomersExcludingMyself.filter(parent => parent.id !== customer.parentCompanyId);
                state.availableSubdivisions = allCustomersExcludingParent.filter(customer => customer.parentCompanyId === 0);
            }
        },
        addCustomerToList(state, payload) {
            const newCustomer = {
                id: payload.id,
                name: payload.name,
                abbreviation: payload.abbreviation,
                activeContractCount: 0,
                futureContractCount: 0,
                parentCompanyId: payload.parentCompanyId,
                subdivisions: payload.subdivisions,
                vat: payload.vat,
                parentCompany: payload.parentCompany,
                street: payload.street,
                houseNumber: payload.houseNumber,
                postalCode: payload.postalCode,
                city: payload.city,
            };
            state.customers = [...state.customers, newCustomer];
        },
        addContractToSelectedCustomerDetail(state, payload) {
            const contractSummaryDto = {
                id: payload.id,
                userId: payload.userId,
                username: payload.username,
                contractPeriod: payload.contractPeriod
            };
            state.selectedCustomerDetail.contractSummaryDtos = [...state.selectedCustomerDetail.contractSummaryDtos, contractSummaryDto];
        },
        setShiftTypesForSelectedCustomerDetail(state, payload) {
            state.selectedCustomerDetail.shiftTypeDtos = payload.shiftTypeDtos;
        },
        setBonusRatesForSelectedCustomerDetail(state, payload) {
            state.selectedCustomerDetail.bonusRateDtos = payload.bonusRateDtos;
        },
        setBonusTypes(state, payload) {
            state.bonusTypes = payload;
        },
        updateSelectedCustomerDetail(state, payload) {
            let parentCompany = state.customers.filter(parent => parent.id === payload.parentCompanyId);
            state.selectedParentCompany = parentCompany[0];
            if (state.selectedCustomerDetail.id === payload.id) {
                state.selectedCustomerDetail = {
                    ...state.selectedCustomerDetail,
                    id: payload.id,
                    name: payload.name,
                    abbreviation: payload.abbreviation,
                    activeContractCount: 0,
                    futureContractCount: 0,
                    subdivisions: payload.subdivisions,
                    vat: payload.vat,
                };
            } else {
                state.selectedCustomerDetail = {};
            }
        },
        setCustomersMinimalInfo(state, payload) {
            const dataToObjects = [];
            payload.forEach(customer => {
                dataToObjects.push({
                    id: customer.id,
                    name: customer.name,
                });
            });
            state.customersMinimalInfo = dataToObjects;
        },
        updateContractInSelectedCustomerDetail(state, updatedContract) {
            const indexOfUpdatedContract = state.selectedCustomerDetail.contractSummaryDtos.findIndex(contract => contract.id === updatedContract.id);
            if (indexOfUpdatedContract !== -1) {
                state.selectedCustomerDetail.contractSummaryDtos[indexOfUpdatedContract] = updatedContract;
                state.selectedCustomerDetail.contractSummaryDtos = [...state.selectedCustomerDetail.contractSummaryDtos];
            }
        },
    },
    actions: {
        fetchCustomerByLink({commit},link){
            return defaultAxiosClient.get('/administration/customer/'+link).then(response=>commit('setSelectedCustomerDetail',response.data)).catch(()=>commit('resetState'));
        },
        fetchBonusTypes({commit}) {
            return defaultAxiosClient.get(`/administration/bonusRate`)
                .then(response => {
                    commit('setBonusTypes', response.data);
                })
                .catch(() => commit('resetState'));
        },
        fetchCustomers({commit}) {
            return defaultAxiosClient.get(`/administration/customer`)
                .then(response => {
                    commit('setCustomers', response.data._embedded?.customerOverviewDtoList);
                    commit('setCustomersMinimalInfo', response.data._embedded?.customerOverviewDtoList);
                })
                .catch(() => commit('resetState'));
        },
        fetchDetailsForSelectedCustomer({commit, state}) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.get(`/administration/customer/${customerId}`)
                .then(response => commit('setSelectedCustomerDetail', response.data))
                .catch(() => commit('resetState'));
        },
        fetchDetailsForParentCustomer({commit}, customerId) {
            return defaultAxiosClient.get(`/administration/customer/${customerId}`)
                .then(response => commit('setSelectedParentCompanyDetail', response.data))
                .catch(() => commit('resetState'));
        },
        createCustomer({commit}, createCustomerDto) {
            return defaultAxiosClient.post("/administration/customer", createCustomerDto)
                .then(response => commit('addCustomerToList', response.data));
        },
        createShiftType({commit, state}, createShiftTypeDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.post(`/administration/customer/${customerId}/shifttype`, createShiftTypeDto)
                .then(response => commit('setShiftTypesForSelectedCustomerDetail', response.data));
        },
        createBonusRate({commit, state}, createBonusRateDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.post(`/administration/customer/${customerId}/bonusRate`, createBonusRateDto)
                .then(response => commit('setBonusRatesForSelectedCustomerDetail', response.data));
        },
        updateShiftTypeFromCustomer({commit, state}, updateShiftTypeDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.put(`/administration/customer/${customerId}/update`, updateShiftTypeDto)
                .then(response => commit('setShiftTypesForSelectedCustomerDetail', response.data));
        },
        updateBonusRateFromCustomer({commit, state}, updateBonusRateDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.patch(`/administration/customer/${customerId}/updateBonusRate`, updateBonusRateDto)
                .then(response => commit('setBonusRatesForSelectedCustomerDetail', response.data));
        },
        removeBonusRateFromCustomer({commit, state}, updateBonusRateDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.post(`/administration/customer/${customerId}/removeBonusRate`, updateBonusRateDto)
                .then(response => commit('setBonusRatesForSelectedCustomerDetail', response.data));
        },
        replaceBonusRatesFromCustomer({commit, state}, updateBonusRateDtos) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.put(`/administration/customer/${customerId}/replaceBonusRates`, updateBonusRateDtos)
                .then(response => commit('setBonusRatesForSelectedCustomerDetail', response.data));
        },
        updateSubdivisionsFromCustomer({commit, state}, subdivisionToUpdatesId) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.put(`/administration/customer/${customerId}/updateSubdivisions`, subdivisionToUpdatesId)
                .then(response => commit('updateSelectedCustomerDetail', response.data));
        },
        updateShiftTypeActivityFromCustomer({commit, state}, updateShiftTypeDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.put(`/administration/customer/${customerId}/shifttype`, updateShiftTypeDto)
                .then(response => commit('setShiftTypesForSelectedCustomerDetail', response.data));
        },
        archiveShiftTypeFromCustomer({commit, state}, shiftTypeId){
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.delete(`/administration/customer/${customerId}/${shiftTypeId}`)
                .then(response => commit('setShiftTypesForSelectedCustomerDetail', response.data));
        },
        updateCustomer({commit, state}, updateCustomerDto) {
            const customerId = state.selectedCustomer.id;
            return defaultAxiosClient.put(`/administration/customer/${customerId}`, updateCustomerDto)
                .then(response => commit('updateSelectedCustomerDetail', response.data));
        },
        fetchConfirmedEmailsList({commit}){
            return defaultAxiosClient.get(`administration/confirmedEmail`)
                .then(response => {
                    commit('setConfirmedEmails', response.data);})
                .catch(() => commit('resetState'));
        },
        updateSubdivisionWorkHours({commit, state}, updateSubdivisionWorkHoursDto) {
            const subdivisionId = updateSubdivisionWorkHoursDto.subdivisionId;
            return defaultAxiosClient.put(`/administration/customer/${subdivisionId}`, updateSubdivisionWorkHoursDto.subdivision)
                .then(response => {
                    response.id = state.selectedCustomerDetail.id;
                    commit('updateSelectedCustomerDetail', response.data);
                });
        },
        addSubdivisionToCustomer({commit}, addSubdivisionDto) {
            const parentId = addSubdivisionDto.parentId;
            const subdivisionId = addSubdivisionDto.subdivisionId;
            defaultAxiosClient.post(`administration/customer/${parentId}/subdivision/${subdivisionId}`)
                .then(response => {
                    commit('setSelectedSubdivisions', response.data);
                    commit('setAvailableSubdivisions', response.data);
                });
        },
        toggleCustomerActive({commit, state}, updateActivationStatusDto){
            return defaultAxiosClient.patch(`/administration/customer/${state.selectedCustomerDetail.id}/toggleActive`, updateActivationStatusDto)
                .then(response => {
                    commit('setSelectedCustomerDetailActiveValue', response.data.active);
                });
        }
    }
};

export default customer;